export const healthCheck: string = "/healthCheck";
export const home: string = "/home";
export const otp: string = "/otp";
export const approval: string = "/approval";
export const expiration: string = "/expiration";
export const confirmation: string = "/confirmation";
